import React, { useEffect, useState } from "react";
import { Routes as Switch, Route, useLocation, Navigate, useNavigate } from "react-router-dom";

import { useRecoilState, useSetRecoilState } from "recoil";
import { userInfo, userCredentials, rioNegroServices, snackbarData } from "./recoilState/GlobalState";
import { useUbicacion } from "components/utils/useUbicacion";

import { getUserCredentials } from "services/getUserCredentials";
import { checkAuth } from "services/checkAuth";
import { usuarioMinimosGet } from "services/services-mia";

import ProtectedRoute from "./components/route/ProtectedRoute";
import { CircularIndeterminate, Header } from "components";
import SnackBar from "components/utils/snackbars/Snackbar";

import {
  Dashboard,
  Usuarios,
  Login,
  UsuariosXServicio,
  UserDetailsDashboard
} from "./pages";

import { Routes as ROUTES } from "./consts/Routes-App";

import ServiceRoute from "components/route/ServiceRoute";
import { merchantLogoGet } from "services/services-mia/merchant";
import { loginServicioGet } from "services/services-mia/login";

import s from "./App.module.scss"
import DespachantesProgramaCalor from "pages/programa-calor/despachantes/index";
import BeneficiariosProgramaCalor from "pages/programa-calor/beneficiarios";
import BeneficiariosEntregaSociales from "pages/entregas-sociales/beneficiarios";
import DespachantesEntregaSociales from "pages/entregas-sociales/despachantes";
import InformesAsisteRN from "pages/entregas-sociales/informes";
import RubosEntregasSociales from "pages/entregas-sociales/rubros";
import ArticulosEntregasSociales from "pages/entregas-sociales/articulos";
import { subscribe, unsubscribe } from "./utils/eventManager.js";
import BeneficiariosNavidad from "pages/programa-navidad/beneficiarios";
import ComerciosNavidad from "pages/programa-navidad/despachantes";
import ProgramasNavidad from "pages/programa-navidad/programas";
import UsuariosGlobales from "pages/usuariosGlobales/beneficiarios";
import InformesProgramaSocial from "pages/programa-navidad/informes";
import Titulos from "pages/programa-salud/personal/titulos/Titulos";

import {
  AreasPrograma, CAPS,
  Departamentos, Divisiones,
  ControlHorarios, Horarios, Unidades, Hospitales,
  Niveles, Organigrama, Postas,
  Puestos, Zonas, URESA, UsuariosInternos,
  Funciones, RegimenesHorario, Agrupamientos,
  Feriados, SeriesFeriados
} from 'pages/programa-salud/index'
// Sin definir todavia: la pagina es un clon de titulos sin adaptar.
// import HorariosAgentes from "pages/programa-salud/personal/horarios-agentes/HorariosAgentes";
import Cargos from "pages/programa-salud/personal/cargos/Cargos";
import Agentes from "pages/programa-salud/personal/agentes/Agentes";

export default function App() {
  const [loading, setLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(false);
  // const [isOpen, setIsOpen] = useState(false);
  const [credentials, setCredentials] = useRecoilState(userCredentials);
  // const [routeError, setRouteError] = useState(false);
  const [info, setInfo] = useRecoilState(userInfo);
  const setServices = useSetRecoilState(rioNegroServices);
  const setSnackBarInfo = useSetRecoilState(snackbarData);
  const location = useLocation();
  // const navigate = useNavigate();

  // App es el dueño: la pide una vez al arrancar y queda escuchando si el permiso
  // cambia. El login la lee del mismo estado y puede reintentar.
  useUbicacion({ pedirAlMontar: true });

  useEffect(() => {
    setLoading(true);
    (async () => {
      const newCredentials = await getUserCredentials();
      if (newCredentials) {
        setCredentials(newCredentials);
        const userData = await usuarioMinimosGet(newCredentials);
        const { result: merchantData } = await merchantLogoGet({}, newCredentials);
        setInfo({ ...merchantData[0], ...userData });
        const { result: servicesData } = await loginServicioGet({}, newCredentials);
        setServices(servicesData);
      }
      setIsAuth(checkAuth());
      setLoading(false);
    })();
  }, [setCredentials, setInfo, setServices]);

  useEffect(() => {
    if (loading) return;
    setIsAuth(checkAuth());
  }, [credentials, loading]);

  // Los errores de servicio los emite el interceptor de axiosPost; sin este listener
  // el emit queda en la nada y ningún error de la app llega a mostrarse.
  useEffect(() => {
    const handleErrorServer = (data) => {
      setSnackBarInfo({
        message: data?.message || "Error de servidor",
        severity: "error",
        open: true,
      });
    };
    // La redirección a login de la sesión expirada ya la hace axiosPost con
    // window.location.assign(fallbackURL); acá solo avisamos.
    const handleSessionExpired = (data) => {
      setSnackBarInfo({
        message: data?.message || "Su sesion expiro por falta de actividad",
        severity: "error",
        open: true,
      });
    };
    subscribe("serverError", handleErrorServer);
    subscribe("sessionExpired", handleSessionExpired);
    return () => {
      unsubscribe("serverError", handleErrorServer);
      unsubscribe("sessionExpired", handleSessionExpired);
    };
  }, [setSnackBarInfo]);

  if (loading) return <CircularIndeterminate />;
  return (
    <div className={s.container}>
      <div className={setIsAuth.header}>
        {location.pathname !== ROUTES.login.route && <Header />}

      </div>
      <div className={s.body}>
        <SnackBar />

        <Switch>
          <Route path={ROUTES.login.route} exact element={<Login />} />

          <Route
            element={
              <ProtectedRoute
                redirectProtectedRoute={ROUTES.login.route}
                isAuth={isAuth}
              />
            }
          >
            <Route
              path={ROUTES.dashboard.route}
              exact
              element={<Dashboard route={ROUTES.dashboard} />}
            />
            <Route
              path={ROUTES.usuarios.route}
              exact
              element={<Usuarios route={ROUTES.usuarios} />}
            />
            <Route
              path={"usuarios/:usuarioId/details"}
              element={<UserDetailsDashboard />}
            />
            {/* Fuera de esta entrega: solo se expone Programa Salud (RNSALUD).

            <Route
              path="servicio/IDBASE"
              element={<ServiceRoute servicioCod="IDBASE" redirectProtectedRoute={ROUTES.login.route} />}
            >
              <Route
                path="usuarios"
                element={<UsuariosXServicio />}
              />
            </Route>

            */}

            {/* Fuera de esta entrega: solo se expone Programa Salud (RNSALUD).

            <Route
              path="servicio/RNCALOR"
              element={<ServiceRoute servicioCod="RNCALOR" redirectProtectedRoute={ROUTES.login.route} />}
            >
              <Route path="beneficiarios" element={<BeneficiariosProgramaCalor />} />
              <Route path="despachantes" element={<DespachantesProgramaCalor />} />
              <Route
                path="usuarios"
                element={<UsuariosXServicio />}
              />

            </Route>

            */}
            {/* Fuera de esta entrega: solo se expone Programa Salud (RNSALUD).

            <Route
              path="servicio/RNES"
              element={<ServiceRoute servicioCod="RNES" redirectProtectedRoute={ROUTES.login.route} />}
            >
              <Route path="beneficiarios" element={<BeneficiariosEntregaSociales />} />
              <Route path="rubros" element={<RubosEntregasSociales />} />
              <Route path="articulos" element={<ArticulosEntregasSociales />} />
              <Route path="despachantes" element={<DespachantesEntregaSociales />} />
              <Route
                path="usuarios"
                element={<UsuariosXServicio />}
              />
              <Route
                path="informes"
                element={<InformesAsisteRN />}
              />

            </Route>

            */}
            {/* Fuera de esta entrega: solo se expone Programa Salud (RNSALUD).

            <Route
              path="servicio/RNPSOCIAL"
              element={<ServiceRoute servicioCod="RNPSOCIAL" redirectProtectedRoute={ROUTES.login.route} />}
            >
              <Route path="programas" element={<ProgramasNavidad />} />
              <Route path="beneficiarios" element={<BeneficiariosNavidad />} />
              <Route path="comercios" element={<ComerciosNavidad />} />
              <Route path="usuarios" element={<UsuariosXServicio />} />
              <Route path="informes" element={<InformesProgramaSocial />} />
            </Route>

            */}
            <Route
              path="servicio/RNSALUD"
              element={<ServiceRoute servicioCod="RNSALUD" redirectProtectedRoute={ROUTES.login.route} />}
            >
              <Route path="estructuras">
                <Route path="zonas" element={<Zonas />} />
                <Route path="areas" element={<AreasPrograma />} />
                <Route path="niveles" element={<Niveles />} />
                <Route path="hospitales" element={<Hospitales />} />
                <Route path="departamentos" element={<Departamentos />} />
                <Route path="divisiones" element={<Divisiones />} />
                <Route path="unidades" element={<Unidades />} />
                <Route path="caps" element={<CAPS />} />
                <Route path="uresa" element={<URESA />} />
                <Route path="puestos" element={<Puestos />} />
                <Route path="postas" element={<Postas />} />
              </Route>
              <Route path="personal">
                <Route path="titulos" element={<Titulos />} />
                <Route path="cargos" element={<Cargos />} />
                <Route path="regimenesHorario" element={<RegimenesHorario />} />
                <Route path="funciones" element={<Funciones />} />
                <Route path="agrupamientos" element={<Agrupamientos />} />
                <Route path="horarios" element={<Horarios />} />
                <Route path="agentes" element={<Agentes />} />
              </Route>
              {/* <Route path="agentes-horarios" element={<HorariosAgentes />} /> */}
              <Route path="usuarios-internos" element={<UsuariosInternos />} />
              <Route path="organigrama" element={<Organigrama />} />
              <Route path="feriados">
                <Route path="nombres" element={<Feriados />} />
                <Route path="series" element={<SeriesFeriados />} />
              </Route>
              <Route path="controlHorarios" element={<ControlHorarios />} />
            </Route>
            <Route
              path={ROUTES.usuariosGlobales.route}
              exact
              element={<UsuariosGlobales />}
            />
            <Route
              path="/*"
              element={<Dashboard />}
            />
          </Route>
        </Switch>
      </div>
    </div>
  );
}
